<a class="next" title="Próximo" (click)="siguienteAlbaran()">
  <img class="svg" src="assets/img/active-arrow.svg" alt="Próximo">
</a>